import React, {forwardRef, useState} from 'react'
import { Btn, FieldSet, FormWrapper, Input, TextArea, Error, FormContainer, Heading, NumInput } from './FormElems'
import { Link, useNavigate} from 'react-router-dom';
import { Modal } from '../modal/Modal';
import {Button} from '../info_section/Info2Elems'
import { useImperativeHandle } from 'react';

const initialState = {
    tipo: '',
    nome: '',
    email: '',
    contacto: '',
    morada: '',
    tijolos: '',
}

const Form = () => {
    const [state, setState] = useState(initialState);
    const [error, setError] = useState('');
    const navigate = useNavigate();


    const handleSubmit = e => {
        e.preventDefault();
        
        for(let key in state) {
            if(state[key]==='') {
                setError(`Preencha o campo ${key}!`)
                return
            }
        }
        setError('');
        navigate("/simulator/results", {
            state: {
                type: state.tipo,
                name: state.nome,
                email: state.email,
                contact: state.contacto,
                address: state.morada,
                bricks: state.tijolos
            }
           });
    }

    const handleInput = e => {
        const input = e.currentTarget.name;
        const value = e.currentTarget.value;

        setState(prev => ({...prev, [input]:value}));
    }

  return (
    <>
            <FormContainer>
                <FieldSet required>
                    <legend>Tipo de Cliente</legend>
                    <label>
                        <input type='radio' value='private' name='tipo' checked={state.tipo==='private'} onChange={handleInput}/>
                        Privado
                    </label>
                    <label>
                        <input type='radio' value='business' name='tipo' checked={state.tipo==='business'} onChange={handleInput}/>
                        Empresarial
                    </label>
                </FieldSet>
                <label htmlFor='name'>Nome</label>
                <Input type='text' name='nome' required value={state.nome} onChange={handleInput}/>
                <label htmlFor='email'>E-mail</label>
                <Input type='email' name='email' required value={state.email} onChange={handleInput}/>
                <label htmlFor='phone'>Contacto Telefónico</label>
                <NumInput type='tel' name='contacto' required value={state.contacto} onChange={handleInput} pattern="[9]{1}[1-3,6]{1}[0-9]{6}|[2]{1}[0-9]{8}"/>
                <div style={{"height": "20px"}}/>
                <label htmlFor='address'>Morada</label>
                <Input type='text' name='morada' required value={state.morada} onChange={handleInput}/>
                <label htmlFor='bricks'>Número de Tijolos</label>
                <NumInput type='number' name='tijolos' required value={state.tijolos} onChange={handleInput}/>
                <small>O tijolo tem as dimensões de 230x107x70mm</small>
                <div style={{"height": "20px"}}/>
                {error && (
                    <Error><p>{error}</p></Error>
                )}
                <Btn onClick={handleSubmit}>CALCULAR</Btn>
            </FormContainer>
    </>
  )
};

export default Form